

// import React from "react";
// import "../css/About.css";
// import about from "./about.webp"
// import { useNavigate } from "react-router-dom";

// function About() {
//     const navigate = useNavigate();
//     const handleClick = () =>{
//         navigate('/decants')
//     }
//     const handleViewGuide = () => {
//         navigate('/bottle-guide')
//     }
//   return (
//     <section className="about-wrapper">

//       <div className="about-hero">
//         <h1>Your Scent Journey Starts Here</h1>
//         <p>
//           Discover premium decants — authentic, affordable and delivered fast.
//         </p>
//       </div>

//       <div className="about-story">
//         <div>
//           <h2>About Scented Nation</h2>
//           <p>
//             We created Scented Nation so fragrance lovers can experience luxury
//             perfumes — without committing to expensive full bottles.
//           </p>

//           <p>
//             Every decant is carefully filled from original bottles,
//             sealed hygienically and labeled clearly, so you know exactly what
//             you’re getting.
//           </p>
//         </div>

//         <img src={about} alt="Fragrance bottles" />
//       </div>
//       <div className="about-cards">

//         <div className="about-card">
//           <div>
//             <h2>Fragrance Decant Collection</h2>
//             <p>
//               Explore authentic luxury fragrances in 2ml — 30ml sizes,
//               perfect for sampling and collecting.
//             </p>
//           </div>

//           <button className="about-btn" onClick={handleClick}>
//             View Decants →
//           </button>
//         </div>

//         <div className="about-card">
//           <div>
//             <h2>Bottle Level Guide</h2>
//             <p>
//               Transparent bottle reference photos — see exactly how much perfume
//               you’ll receive.
//             </p>
//           </div>

//           <button className="about-btn" onClick={handleViewGuide}>
//             View Level Guide →
//           </button>
//         </div>

//       </div>

//     </section>
//   );
// }

// export default About;



import React, { useEffect } from "react";
import "../css/About.css";
import about from "./about.webp";
import { useNavigate } from "react-router-dom";

function About() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/decants");
  };

  const handleViewGuide = () => {
    navigate("/bottle-guide");
  };

  // --- Scroll animation ---
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target); // animate once
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-wrapper">

      {/* <div className="about-hero reveal">
        <h1>Your Scent Journey Starts Here</h1>
        <p>
          Discover premium decants — authentic, affordable and delivered fast.
        </p>
      </div>

      <div className="about-story">
        <div className="reveal delay-1">
          <h2>About Scented Nation</h2>

          <p>
            We created Scented Nation so fragrance lovers can experience luxury
            perfumes — without committing to expensive full bottles.
          </p>

          <p>
            Every decant is carefully filled from original bottles,
            sealed hygienically and labeled clearly — so you know exactly
            what you’re getting.
          </p>
        </div>

        <img
          src={about}
          alt="Fragrance bottles"
          className="reveal delay-2"
        />
      </div> */}

      <div className="about-cards">

        <div className="about-card reveal delay-1">
          <div>
            <h2>Fragrance Decant Collection</h2>
            <p>
              Explore authentic luxury fragrances in 2.5ml — 30ml sizes,
              perfect for sampling and collecting.
            </p>
          </div>

          <button className="about-btn" onClick={handleClick}>
          Decants List →
          </button>
        </div>

        <div className="about-card reveal delay-2">
          <div>
            <h2>View Sample Decants</h2>
            <p>
              Decant bottle reference photos — see exactly how much perfume
              you’ll receive.
            </p>
          </div>

          <button className="about-btn" onClick={handleViewGuide}>
          View Sample Decants →
          </button>
        </div>

      </div>

    </section>
  );
}

export default About;

